<template>
    <div>
        <p class="pause-question" v-text="$t('PAUSE_DELIVERIES_REMINDER_STEP')"></p>
        <Calendar
            class="calendar-container"
            :customStyle=customStyle
            :deliverable-days="[]"
            :controlLimit="10"
            :lockTooltipText="$t('CALENDAR_TOO_LATE_TO_MAKE_CHANGES')"
            :isPauseFlow="true"
            :allowMonthToggling="true"
            :canSelectAnyDate="true"/>

        <button @click.prevent="pauseWithRestartDate" class="btn btn--primary btn--full-width restart-date--confirm">
            <span v-if="processing" v-text="$t('SUBMIT_BUTTON_PLEASE_WAIT')"/>
            <span v-else v-text="mainCTAText"/>
        </button>
        <button v-if="isPauseFlow" v-text="noThanksCTAText"
                @click.prevent="nextStep" class="btn btn--secondary-black btn--full-width restart-date--reject">
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Calendar } from '@freddiesflowers/frontend-component-library';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import { CSPageEvents } from '@/helpers/GAHelpers';

let subscriptionService = new SubscriptionService();

export default {
    name: 'ReminderStep',
    components: { Calendar },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
        },
        isPauseFlow: {
            type: Boolean,
        },
    },
    data() {
        return {
            stageId: 'reminder',
            selectedRestartDate: null,
            errorHandler: new ErrorResponseHandler(),
            processing: false,
        };
    },
    mounted() {
        this.$root.$on('selected-date', (payload) => {
            this.selectedRestartDate = payload;
        });
    },
    computed: {
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
        customStyle() {
            return {
                container: {
                    width: '360px',
                },
                dayWrapper: {
                    height: '49px',
                    width: '52px',
                },
                dayText: {
                    height: '35px',
                    width: '35px',
                    fontSize: '16px',
                },
            };
        },
        noThanksCTAText() {
            return this.isPauseFlow ? this.$t('PAUSE_DELIVERIES_NO_THANKS') : this.$t('CANCEL_DELIVERIES_NO_THANKS');
        },
        mainCTAText() {
            return this.isPauseFlow ? this.$t('REMIND_ME_PAUSE_DELIVERIES') : this.$t('REMIND_ME_NEXT');
        },
    },
    methods: {
        pauseWithRestartDate() {
            CSPageEvents(`${this.stageId}-accepted`);
            this.processing = true;
            if (!this.selectedRestartDate) return this.nextStep();
            let payload = {
                reason: 'Reminder Step',
                feedback: null,
                resumeDate: this.selectedRestartDate,
                reminder: 1,
            };
            subscriptionService.pauseSubscription(this.subscriptionId, payload)
                .then(() => {
                    this.nextStep();
                    this.processing = false;
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },

        nextStep() {
            // if (this.isPauseFlow) return this.$emit('deliveries-paused');
            this.$emit('input', this.updatedSteps);
            CSPageEvents(`${this.stageId}-paused`);
        },
    },
};
</script>
<style lang="scss" scoped>
.pause-question {
    margin: 15px 0;
    text-align: left;
}
.restart-dates {
    margin-bottom: 20px;
}
.restart-date {
    margin: 8px 0;
}
.restart-date--label {
    font-size: 18px;
}
.restart-date--confirm {
    margin: 54px 0 0;
    background: #262323;
    height: 40px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
}
.restart-date--reject {
    margin: 10px 0 0px;
    height: 40px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
}
</style>
